import EnhancedLazyLoad from './enhancedLazyLoad'

export default EnhancedLazyLoad
